var map = {
	"./datascience.svg": "5a6b",
	"./ddd.svg": "4617",
	"./line.svg": "18e5",
	"./mobiledev.svg": "e24f",
	"./otherasmnt.svg": "d63b",
	"./prgmnglang.svg": "3c0f",
	"./softwaredev.svg": "3e7b",
	"./softwareeng.svg": "b66e",
	"./softwaretest.svg": "b2a8",
	"./webdev.svg": "d970"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f546";